import React from "react";

function RapidMixerGranulator() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Rapid Mixer Granulator (RMG)</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Rapid Mixer Granulator (RMG)</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE — CENTER */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/15.png"
                        alt="Rapid Mixer Granulator"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Rapid Mixer Granulator (RMG)</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Rapid Mixer Granulator (RMG) is designed for high-speed
                      wet mixing, granulation, and homogenization processes. It is
                      widely used in pharmaceutical formulation to achieve uniform
                      granules with excellent flow and compressibility.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Featuring a high-shear impeller, chopper assembly, precise
                      control system, and robust stainless-steel construction,
                      the RMG ensures fast processing, reduced batch time, and
                      high-quality granules.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/15.png"
                            alt="RMG Image"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/16.png"
                            alt="RMG Image"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    {/* Small RMG Models */}
                    <h5 style={{ marginTop: "20px" }}>Small Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MG-25</td>
                          <td>DPM-MG-50</td>
                          <td>DPM-MG-125</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>15–20 kg</td>
                          <td>30–40 kg</td>
                          <td>75–125 kg</td>
                        </tr>

                        <tr>
                          <td>Impeller Motor</td>
                          <td>5 HP</td>
                          <td>7.5 HP</td>
                          <td>10 HP</td>
                        </tr>

                        <tr>
                          <td>Chopper Motor</td>
                          <td>1 HP</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                        </tr>

                      </tbody>
                    </table>

                    {/* Medium RMG Models */}
                    <h5 style={{ marginTop: "20px" }}>Medium Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MG-150</td>
                          <td>DPM-MG-250</td>
                          <td>DPM-MG-300</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>90–150 kg</td>
                          <td>150–250 kg</td>
                          <td>180–300 kg</td>
                        </tr>

                        <tr>
                          <td>Impeller Motor</td>
                          <td>12.5 HP</td>
                          <td>15 HP</td>
                          <td>20 HP</td>
                        </tr>

                        <tr>
                          <td>Chopper Motor</td>
                          <td>5 HP</td>
                          <td>7.5 HP</td>
                          <td>10 HP</td>
                        </tr>

                      </tbody>
                    </table>

                    {/* Large RMG Models */}
                    <h5 style={{ marginTop: "20px" }}>Large Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MG-400</td>
                          <td>DPM-MG-600</td>
                          <td>DPM-MG-800</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>250–400 kg</td>
                          <td>400–600 kg</td>
                          <td>600–800 kg</td>
                        </tr>

                        <tr>
                          <td>Impeller Motor</td>
                          <td>25 HP</td>
                          <td>30 HP</td>
                          <td>40 HP</td>
                        </tr>

                        <tr>
                          <td>Chopper Motor</td>
                          <td>12.5 HP</td>
                          <td>15 HP</td>
                          <td>20 HP</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/fluid-bed-dryer">
                          Fluid Bed Dryer (FBD)
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mass-mixer">
                          Mass Mixer Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default RapidMixerGranulator;
